export const DISEGNI = [
  {
    "ddl": "1",
    "titolo": "Nuove formule di giuramento",
    "riferimento": "Legge 23 dicembre 1946, n. 478. G.U. n. 3 del 4 gennaio 1947."
  },
  {
    "ddl": "2",
    "titolo": "Modifiche al testo unico della legge comunale e provinciale approvato con Regio decreto 3 marzo 1934, n.383, e successive modificazioni",
    "riferimento": "Legge 28 marzo 1947, n. 530. G.U. n. 146 del 30 giugno 1947."
  },
  {
    "ddl": "3",
    "titolo": "Modificazioni al Regio decreto legislativo 31 maggio 1946, n.560, relativo alla riforma dell'ordinamento della Corte di assise",
    "riferimento": null
  },
  {
    "ddl": "4",
    "titolo": "Norme complementari al Regio decreto legislativo 31 maggio 1946, n.560, relativo alla riforma dell'ordinamento della Corte di assise",
    "riferimento": null
  },
  {
    "ddl": "5",
    "titolo": "Procedura per i reati di competenza della Corte di assise",
    "riferimento": null
  },
  {
    "ddl": "6",
    "titolo": "Partecipazione dell'Italia agli Accordi firmati a Bretton Woods, New Hampshire, U.S.A., il 22 luglio 1944 dai rappresentanti delle Nazioni Unite, per la costituzione del Fondo monetario internazionale e della Banca internazionale per la ricostruzione e lo sviluppo",
    "riferimento": "Legge 23 marzo 1947, n. 132. G.U. n. 71 del 27 marzo 1947, S.O."
  },
  {
    "ddl": "7",
    "titolo": "Riforma del Codice di procedura civile",
    "riferimento": null
  },
  {
    "ddl": "8",
    "titolo": "Approvazione dell' Accordo internazionale per la costituzione della Organizzazione delle Nazioni Unite per l'alimentazione e l'agricoltura, concluso a Quebec il 16 ottobre 1945",
    "riferimento": "Legge 16 maggio 1947, n. 546. G.U. n. 147 del 1° luglio 1947."
  },
  {
    "ddl": "9",
    "titolo": "Modificazioni al Codice penale per la difesa delle istituzioni repubblicane",
    "riferimento": "Legge 11 novembre 1947, n. 1317. G.U. n. 278 del 3 dicembre 1947."
  },
  {
    "ddl": "10",
    "titolo": "Norme per la repressione dell'attività fascista e dell'attività diretta alla restaurazione dell'istituto monarchico",
    "riferimento": "Legge 3 dicembre 1947, n. 1546. G.U. n. 13 del 17 gennaio 1948."
  },
  {
    "ddl": "11",
    "titolo": "Disposizioni relative al soggiorno nel territorio dello Stato ed ai beni degli ex regnanti di casa Savoia",
    "riferimento": null
  },
  {
    "ddl": "12",
    "titolo": "Ordinamento dell'industria cinematografica nazionale",
    "riferimento": "Legge 16 maggio 1947, n. 379. G.U. n. 122 del 30 maggio 1947."
  },
  {
    "ddl": "13",
    "titolo": "Norme per il collocamento a riposo, a domanda o d'ufficio, dei dipendenti degli enti pubblici locali e dei segretari comunali",
    "riferimento": null
  },
  {
    "ddl": "14",
    "titolo": "Convalida del decreto legislativo del Capo provvisorio dello Stato in data 29 marzo 1947, n.143, concernente l'istituzione di una imposta straordinaria progressiva sul patrimonio",
    "riferimento": "Legge 1° settembre 1947, n. 828. G.U. n. 202 del 4 settembre 1947, S.O."
  },
  {
    "ddl": "15",
    "titolo": "Disposizioni sulla stampa",
    "riferimento": "Legge 8 febbraio 1948, n. 47. G.U. n. 43 del 20 febbraio 1948."
  },
  {
    "ddl": "16",
    "titolo": "Norme per la disciplina dell'elettorato attivo e per la tenuta e la revisione annuale delle liste elettorali",
    "riferimento": "Legge 7 ottobre 1947, n. 1058. G.U. n. 235 del 13 ottobre 1947, S.O."
  },
  {
    "ddl": "17",
    "titolo": "Approvazione dell' Accordo concluso a Parigi il 10 settembre 1946 tra il Governo italiano ed il Governo egiziano circa il risarcimento dei danni subiti dall' Egitto per effetto delle operazioni militari svoltesi nel suo territorio ed il dissequestro dei beni italiani in Egitto",
    "riferimento": "Legge 16 maggio 1947, n. 512. G.U. n. 144 del 27 giugno 1947."
  },
  {
    "ddl": "18",
    "titolo": "Approvazione degli Accordi commerciali e di pagamento stipulati in Roma, tra l'Italia e la Svezia, il 24 novembre 1945",
    "riferimento": "Legge 29 settembre 1947, n. 1655. G.U. n. 40 del 17 febbraio 1948."
  },
  {
    "ddl": "19",
    "titolo": "Norme per la istituzione dell'Opera di valorizzazione della Sila",
    "riferimento": "Legge 31 dicembre 1947, n. 1629. G.U. n. 30 del 6 febbraio 1948."
  },
  {
    "ddl": "20",
    "titolo": "Legge per l'elezione dei Membri della Camera dei Deputati",
    "riferimento": null
  },
  {
    "ddl": "21",
    "titolo": "Revoca dall'impiego per mancata fede al giuramento",
    "riferimento": "Legge 16 novembre 1947, n. 1318. G.U. n. 278 del 3 dicembre 1947."
  },
  {
    "ddl": "21bis",
    "titolo": "Proroga del termine di otto mesi previsto dall'articolo 4 del decreto legislativo 16 marzo 1946, n.98, per la durata dell' Assemblea Costituente",
    "riferimento": "Legge costituzionale 21 febbraio 1947, n. 1. G.U. n. 44 del 22 febbraio 1947."
  },
  {
    "ddl": "22",
    "titolo": "Proroga del termine previsto dall'articolo 4 del decreto legislativo 16 marzo 1946, n.98, per la durata dell' Assemblea Costituente",
    "riferimento": "Legge costituzionale 17 giugno 1947, n. 2. G.U. n. 137 del 19 giugno 1947."
  },
  {
    "ddl": "23",
    "titolo": "Approvazione del Trattato di pace tra le Potenze Alleate ed Associate e l'Italia, firmato a Parigi il 10 febbraio 1947",
    "riferimento": "Legge 2 agosto 1947, n. 811. G.U. n. 200 del 2 settembre 1947."
  },
  {
    "ddl": "24",
    "titolo": "Approvazione dello scambio di Note effettuato in Roma fra l'Italia e la Francia, il 1° giugno 1946, circa il recupero di navi mercantili francesi affondate nelle acque territoriali italiane",
    "riferimento": "Legge 13 novembre 1947, n. 1422. G.U. n. 294 del 23 dicembre 1947."
  },
  {
    "ddl": "25",
    "titolo": "Approvazione dell' Atto di emendamento della Costituzione dell' Organizzazione Internazionale del Lavoro e della Convenzione per la revisione parziale delle Convenzioni adottate dalla Conferenza Generale dell' Organizzazione Internazionale del Lavoro nelle sue prime 28 Sessioni, per assicurare l'esercizio futuro di alcune funzioni di cancelleria affidate dalle predette Convenzioni al Segretario Generale della Società delle Nazioni e per apportarvi emendamenti complementari resisi necessari in seguito alla estinzione della Società delle Nazioni ed all'emendamento della costituzione dell' Organizzazione del Lavoro",
    "riferimento": "Legge 13 novembre 1947, n. 1622. G.U. n. 27 del 3 febbraio 1948, S.O."
  },
  {
    "ddl": "26",
    "titolo": "Approvazione degli Accordi di carattere economico conclusi in Roma, tra l'Italia e la Francia, il 22 dicembre 1946",
    "riferimento": "Legge 16 dicembre 1947, n. 1757. G.U. n. 66 del 18 marzo 1948."
  },
  {
    "ddl": "27",
    "titolo": "Approvazione degli Accordi finanziari conclusi a Roma, a mezzo scambi di Note, tra il Governo italiano e il Governo del Regno Unito, il 17 aprile 1947",
    "riferimento": null
  },
  {
    "ddl": "28",
    "titolo": "Approvazione dell'Accordo fra l'Italia e la Cecoslovacchia relativo all'immigrazione di lavoratori italiani in Cecoslovacchia, nonché del primo Protocollo addizionale all'Accordo suddetto, conclusi a Roma il 10 febbraio 1947",
    "riferimento": null
  },
  {
    "ddl": "29",
    "titolo": "Approvazione dell'Accordo fra l'Italia e l'Argentina in materia di emigrazione, concluso a Roma il 21 febbraio 1947",
    "riferimento": "Legge 13 novembre 1947, n. 1452. G.U. n. 301 del 31 dicembre 1947."
  },
  {
    "ddl": "30",
    "titolo": "Approvazione degli Accordi di carattere economico, conclusi in Roma, tra l'Italia ed i Paesi Bassi, il 30 Agosto 1946",
    "riferimento": "Legge 16 dicembre 1947, n. 1672. G.U. n. 44 del 21 febbraio 1948."
  },
  {
    "ddl": "31",
    "titolo": "Approvazione degli Accordi di carattere economico, conclusi in Roma, tra l'Italia e la Danimarca, il 2 marzo 1946",
    "riferimento": "Legge 16 dicembre 1947, n. 1728. G.U. n. 54 del 4 marzo 1948."
  },
  {
    "ddl": "32",
    "titolo": "Approvazione degli Accordi di carattere economico, conclusi in Roma, tra l'Italia e l'Ungheria, il 9 novembre 1946",
    "riferimento": "Legge 16 dicembre 1947, n. 1682. G.U. n. 46 del 24 febbraio 1948."
  },
  {
    "ddl": "33",
    "titolo": "Soppressione del Senato e determinazione della posizione giuridica personale dei suoi componenti",
    "riferimento": "Legge costituzionale 3 novembre 1947, n. 3. G.U. n. 256 del 7 novembre 1947."
  },
  {
    "ddl": "34",
    "titolo": "Conferma della soppressione e della liquidazione dell'Ufficio nazionale metalli e disposizioni per la liquidazione del patrimonio dell'Ufficio nazionale dei metalli non ferrosi e dell'Ufficio industriale dei metalli non ferrosi",
    "riferimento": null
  },
  {
    "ddl": "35",
    "titolo": "Ordinamento dei Corpi consultivi del Ministero della pubblica istruzione",
    "riferimento": "Legge 30 dicembre 1947, n. 1477. G.U. n. 3 del 5 gennaio 1948."
  },
  {
    "ddl": "36",
    "titolo": "Approvazione del Trattato di amicizia e relazioni generali fra la Repubblica Italiana e la Repubblica delle Filippine, firmato a Roma il 9 luglio 1947",
    "riferimento": "Legge 27 novembre 1947, n. 1491. G.U. n. 6 del 9 gennaio 1948."
  },
  {
    "ddl": "37",
    "titolo": "Approvazione dei seguenti atti internazionali: a) Protocollo di emendamento agli Accordi, Convenzioni e Protocolli sugli stupefacenti conclusi all' Aja il 23 gennaio 1912, a Ginevra l' 11 febbraio 1925, il 19 febbraio 1925, 13 luglio 1931, a Bangkok il 27 novembre 1931 ed a Ginevra il 26 giugno 1936; b) Annesso al Protocollo di emendamento agli Accordi, Convenzioni e Protocolli sugli stupefacenti conclusi all' Aja il 23 gennaio 1912, a Ginevra l' 11 febbraio 1925, il 19 febbraio 1925, il 13 luglio 1931, a Bangkok il 27 novembre 1931 ed a Ginevra il 26 giugno 1936",
    "riferimento": "Legge 16 dicembre 1947, n. 1674. G.U. n. 45 del 23 febbraio 1948."
  },
  {
    "ddl": "38",
    "titolo": "Approvazione dello scambio di Note relativo ai danni di guerra ed all'articolo 79 del Trattato di Pace, effettuato in Roma fra l'Italia e la Cina il 30 luglio 1947",
    "riferimento": "Legge 16 dicembre 1947, n. 1443. G.U. n. 300 del 30 dicembre 1947."
  },
  {
    "ddl": "39",
    "titolo": "Approvazione dei seguenti Accordi conclusi ad Ankara tra l'Italia e la Turchia il 12 aprile 1947: a) Accordo commerciale; b) Accordo di pagamento; c) Scambio di Note",
    "riferimento": "Legge 16 dicembre 1947, n. 1657. G.U. n. 41 del 18 febbraio 1948."
  },
  {
    "ddl": "40",
    "titolo": "Approvazione degli Accordi commerciali e di pagamento conclusi in Roma, tra l'Italia ed il Belgio il 18 aprile 1946",
    "riferimento": "Legge 16 dicembre 1947, n. 1763. G.U. n. 74 del 29 marzo 1948, S.O."
  },
  {
    "ddl": "41",
    "titolo": "Approvazione dei seguenti Accordi, conclusi a Roma, fra l'Italia e la Svezia il 19 aprile 1947: a) Accordo Italo-Svedese relativo all'emigrazione di operai italiani in Svezia; b) Protocollo addizionale all'accordo Italo-Svedese relativo all'emigrazione di operai italiani in Svezia",
    "riferimento": "Legge 16 dicembre 1947, n. 1621. G.U. n. 27 del 3 febbraio 1948."
  },
  {
    "ddl": "42",
    "titolo": "Approvazione dei seguenti Accordi, conclusi a Roma tra l'Italia ed il Belgio: a) Protocollo Italo-Belga per il trasferimento di 50.000 minatori italiani in Belgio e scambio di note 23 giugno 1946; b) Scambio di note per l'annullamento dell'articolo 7 del Protocollo suddetto 26-29 ottobre 1947; c) Annesso al Protocollo di emigrazione Italo-Belga 26 aprile 1947; d) Scambio di note per l'applicazione immediata a titolo provvisorio dell' Annesso suddetto 27-28 aprile 1946",
    "riferimento": "Legge 16 dicembre 1947, n. 1663. G.U. n. 42 del 19 febbraio 1948."
  },
  {
    "ddl": "43",
    "titolo": "Approvazione del Trattato di pace e relativo scambio di Note fra la Repubblica italiana e la Repubblica di Cuba firmato all' Avana il 30 giugno 1947",
    "riferimento": "Legge 27 novembre 1947, n. 1442. G.U. n. 300 del 30 dicembre 1947."
  },
  {
    "ddl": "44",
    "titolo": "Approvazione dell'Accordo concluso nel Palazzo Apostolico Vaticano fra la Santa Sede e l'Italia, il 31 marzo 1947, per una nuova delimitazione di alcune zone extra-territoriali nelle adiacenze della Città del Vaticano",
    "riferimento": null
  },
  {
    "ddl": "45",
    "titolo": "Approvazione dei seguenti Accordi conclusi in Roma, tra l'Italia e la Francia, il 21 marzo 1947: a) Accordo relativo all'immigrazione italiana in Francia; b) Accordo speciale relativo agli operai che si recano in Francia per la stagione delle barbabietole; c) Accordo relativo alle condizioni di applicazione della legislazione francese sugli assegni familiari; d) Scambio di Note",
    "riferimento": null
  },
  {
    "ddl": "46",
    "titolo": "Approvazione degli Accordi di carattere economico conclusi in Roma, tra l'Italia e la Norvegia, il 20 luglio 1946",
    "riferimento": null
  },
  {
    "ddl": "47",
    "titolo": "Approvazione dei seguenti Atti internazionali conclusi a Neuchâtel, tra l'Italia ed altri Stati, l' 8 febbraio 1947: a) Accordo per la conservazione o la reintegrazione dei diritti di proprietà industriale colpiti dalla seconda guerra mondiale; b) Protocollo di chiusura; c) Protocollo di chiusura addizionale",
    "riferimento": "Legge 16 dicembre 1947, n. 1623. G.U. n. 28 del 4 febbraio 1948."
  },
  {
    "ddl": "48",
    "titolo": "Modificazioni al decreto legislativo 10 marzo 1946, n.74, per l'elezione della Camera dei Deputati",
    "riferimento": "Legge 20 gennaio 1948, n. 6. G.U. n. 20 del 26 gennaio 1948, S.O."
  },
  {
    "ddl": "49",
    "titolo": "Norme per la prima compilazione delle liste elettorali nella provincia di Gorizia",
    "riferimento": "Legge 12 dicembre 1947, n. 1379. G.U. n. 287 del 15 dicembre 1947."
  },
  {
    "ddl": "50",
    "titolo": "Norme per la limitazione temporanea del diritto di voto ai capi responsabili del regime fascista",
    "riferimento": "Legge 23 dicembre 1947, n. 1453. G.U. n. 301 del 31 dicembre 1947."
  },
  {
    "ddl": "51",
    "titolo": "Elezione del Consiglio della Valle d' Aosta",
    "riferimento": null
  },
  {
    "ddl": "52",
    "titolo": "Proroga dei termini per la presentazione o la conversione in legge dei decreti-legge non ancora presentati o convertiti in legge",
    "riferimento": null
  },
  {
    "ddl": "53",
    "titolo": "Approvazione dell' Accordo concluso a Roma, il 15 maggio 1947, fra il Governo Italiano ed il Comitato intergovernativo per i rifugiati",
    "riferimento": null
  },
  {
    "ddl": "54",
    "titolo": "Approvazione dello scambio di Note verbali fra l'Italia e gli Stati Uniti d' America, effettuato a Roma, il 24-26 settembre 1946, relativo alla sistemazione dei cimiteri di guerra americani in Italia",
    "riferimento": null
  },
  {
    "ddl": "55",
    "titolo": "Approvazione del Protocollo addizionale provvisorio agli Accordi commerciali e di pagamento del 2 marzo 1946 e dello scambio di Note conclusi a Roma fra l'Italia e la Danimarca il 23 maggio 1947",
    "riferimento": null
  },
  {
    "ddl": "56",
    "titolo": "Approvazione degli Accordi di carattere economico e finanziario conclusi a Madrid, fra l'Italia e la Spagna, il 20 giugno 1947",
    "riferimento": null
  },
  {
    "ddl": "57",
    "titolo": "Approvazione dei seguenti Accordi conclusi a Roma, fra l'Italia e la Francia, il 15 maggio 1947: a) Protocollo regolante l'emigrazione di minatori italiani in Francia e la corrispondente fornitura francese di carbone all'Italia; b) Convenzione annessa al Protocollo suddetto che fissa la ripartizione per provenienza e qualità nonché il prezzo di cessione e le condizioni di consegna di carbone all'Italia; c) Scambio di Note per l'entrata in vigore del Protocollo di cui alla lettera a), effettuato in Roma il 17 maggio 1947",
    "riferimento": null
  },
  {
    "ddl": "58",
    "titolo": "Approvazione dei seguenti Accordi conclusi a Montevideo, fra l'Italia e l' Uruguay, il 26 febbraio 1947: a) Trattato di commercio; b) Accordo commerciale; c) Accordo di pagamento; d) Accordo per lo scongelamento degli averi bloccati; e) Protocollo di firma; f) Scambio di Note; e dello scambio di Note effettuato il 29 maggio 1947, portante modifiche agli Accordi suddetti",
    "riferimento": null
  },
  {
    "ddl": "59",
    "titolo": "Approvazione dei seguenti Accordi conclusi all' Aja, fra l'Italia ed i Paesi Bassi, il 18 dicembre 1946: a) Protocollo addizionale all' Accordo commerciale fra l'Italia ed i Paesi Bassi, firmato a Roma il 30 agosto 1946; b) Protocollo addizionale all' Accordo di pagamento fra l'Italia ed i Paesi Bassi, firmato a Roma il 30 agosto 1946; c) Scambio di Note",
    "riferimento": null
  },
  {
    "ddl": "60",
    "titolo": "Approvazione dei seguenti Accordi conclusi ad Atene, il 31 marzo 1947, fra l'Italia e la Grecia: a) Accordo commerciale provvisorio; b) Protocollo annesso A; c) Protocollo annesso B; d) Accordo di pagamento; e) Scambio di Note",
    "riferimento": null
  },
  {
    "ddl": "61",
    "titolo": "Norme per l'elezione del Senato della Repubblica",
    "riferimento": "Legge 6 febbraio 1948, n. 29. G.U. n. 31 del 7 febbraio 1948, S.O."
  },
  {
    "ddl": "62",
    "titolo": "STATUTO SPECIALE PER LA SARDEGNA",
    "riferimento": "Legge costituzionale 26 febbraio 1948, n. 3. G.U. n. 58 del 9 marzo 1948."
  },
  {
    "ddl": "63",
    "titolo": "STATUTO SPECIALE PER IL TRENTINO-ALTO ADIGE",
    "riferimento": "Legge costituzionale 26 febbraio 1948, n. 5. G.U. n. 62 del 13 marzo 1948."
  },
  {
    "ddl": "64",
    "titolo": "STATUTO SPECIALE PER LA VALLE D' AOSTA",
    "riferimento": "Legge costituzionale 26 febbraio 1948, n. 4. G.U. n. 59 del 10 marzo 1948."
  },
  {
    "ddl": "65",
    "titolo": "TESTO COORDINATO DELLO STATUTO SPECIALE PER LA SICILIA",
    "riferimento": "Legge costituzionale 26 febbraio 1948, n. 2. G.U. n. 58 del 9 marzo 1948."
  },
  {
    "ddl": "66",
    "titolo": "Modificazioni alla legge 7 ottobre 1947, n.1058, per la prima elezione della Camera dei Deputati e del Senato della Repubblica",
    "riferimento": "Legge 4 febbraio 1948, n. 24. G.U. n. 29 del 5 febbraio 1948, S.O."
  },
  {
    "ddl": "67",
    "titolo": "Norme per la formazione delle liste elettorali nella provincia di Bolzano",
    "riferimento": "Legge 4 febbraio 1948, n. 25. G.U. n. 29 del 5 febbraio 1948, S.O."
  },
  {
    "ddl": "68",
    "titolo": "Norme per la proponibilità dei giudizi e per le garanzie d'indipendenza della Corte costituzionale",
    "riferimento": "Legge costituzionale 9 febbraio 1948, n. 1. G.U. n. 43 del 20 febbraio 1948."
  }
]